import { memo } from 'react';

import Debug from '@/components/Debug';
import ListCard from '@/ui/components/ListCard';

import type { Props } from './types';

const RequestedDocumentItem = ({ requestedDocument }: Props) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return null;
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <ListCard title={requestedDocument.custom_module_form.healthie_name}>
      <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-gray-600">
        <div className="flex items-center gap-x-2">
          <span className="font-medium">Required After:</span>
          <span>{requestedDocument.required_after_label}</span>
        </div>
        <div className="flex items-center gap-x-2">
          <span className="font-medium">Required At:</span>
          <span>{formatDate(requestedDocument.required_at)}</span>
        </div>
        <div className="flex items-center gap-x-2">
          <span className="font-medium">Resign Required After:</span>
          <span>{requestedDocument.resign_required_after_label}</span>
        </div>
        <div className="flex items-center gap-x-2">
          <span className="font-medium">Resign Required At:</span>
          <span>{formatDate(requestedDocument.resign_required_at)}</span>
        </div>
        {/* Only show row if at least one of the three has data */}
        {(requestedDocument.jurisdiction?.name ||
          requestedDocument.payment_type ||
          requestedDocument.insurance_type) && (
          <div className="flex items-center gap-x-8 w-full">
            {requestedDocument.jurisdiction?.name && (
              <div className="flex items-center gap-x-2">
                <span className="font-medium">Jurisdiction:</span>
                <span>{requestedDocument.jurisdiction.name}</span>
              </div>
            )}
            {requestedDocument.payment_type && (
              <div className="flex items-center gap-x-2">
                <span className="font-medium">Payment Type:</span>
                <span>{requestedDocument.payment_type}</span>
              </div>
            )}
            {requestedDocument.insurance_type && (
              <div className="flex items-center gap-x-2">
                <span className="font-medium">Insurance Type:</span>
                <span>{requestedDocument.insurance_type}</span>
              </div>
            )}
          </div>
        )}
        {/* Only show classifications if there is data */}
        {requestedDocument.classifications && requestedDocument.classifications.length > 0 && (
          <div className="flex items-center gap-x-2 w-full">
            <span className="font-medium">Classifications:</span>
            <span>{requestedDocument.classifications.join(', ')}</span>
          </div>
        )}
        <div className="flex items-center gap-x-8 w-full">
          <div className="flex items-center gap-x-2">
            <span className="font-medium">Apply At:</span>
            <span>{formatDate(requestedDocument.apply_at)}</span>
          </div>
          <div className="flex items-center gap-x-2">
            <span className="font-medium">Last Requested At:</span>
            <span>{formatDate(requestedDocument.last_requested_at)}</span>
          </div>
          <div className="flex items-center gap-x-2">
            <span className="font-medium">Last Signed At:</span>
            <span>{formatDate(requestedDocument.last_signed_at)}</span>
          </div>
        </div>
      </div>

      <Debug object={requestedDocument as object} />
    </ListCard>
  );
};

export default memo(RequestedDocumentItem);
